import axios from 'axios'
import {clearCookies, setCookie} from '@/lib'

const methods = {
  get (url) {
    return axios.get(url).then((resp) => {
      console.log(111, 'get then', resp)
    }).catch((resp) => {
      console.log(111, 'get catch', resp)
    })
  },
  post (url, params) {
    return new Promise((resolve, reject) => {
      axios.post(url + '?api_key=70f71280d5d547b2a7bb370a529aeea1', params, {
        withCredentials: true
      }).then((resp) => {
        let result = resp.data || {}
        if (result.code === 200) {
          resolve(result.data)
        } else if (result.code === 11003 || result.code === 406 || result.code === 11000) {
          clearCookies()
          window.location.href = `https://passport.vip.com/logout?src=${window.encodeURIComponent(window.location.href)}`
        } else {
          reject(result)
        }
      }).catch((resp) => {
        alert(resp.message || resp)
        reject({
          code: resp.code,
          msg: resp.message
        })
      })
    })
  }
}

const Request = (reqArgs, params, params2) => {
  setCookie('XSRF-TOKEN', '', -1, 'vip.com')
  setCookie('XSRF-TOKEN', '', -1, 'rule.vip.com')
  const req = {
    type: 'post'
  }
  if (Object.prototype.toString.call(reqArgs) === '[object String]') {
    req.url = reqArgs
  } else {
    Object.assign(req, reqArgs)
  }
  req.type = req.type || 'post'
  req.type = req.type.toLocaleLowerCase()
  let queryStr = []
  if (params && params2) {
    for (let key in params)  {
      queryStr.push(`${key}=${params[key]}`)
    }
    req.url = queryStr.length ? `${reqArgs.url}?${queryStr.join('&')}` : reqArgs.url
    params = params2
  }
  return methods[req.type](req.url, params)
}

export default Request
